import { log } from "@qgiv/core-js";

export const getIfEmailExistsInCurrentRegistration = ({
    currentRegistration,
    registrations,
    Email,
}) => {
    // create lookup map for registration emails and their index
    const emailAndIndexMap = new Map();
    registrations.forEach((registration, index) => {
        // "new" registration starts off as empty or partially filled object
        // that is missing Email value
        const email =
            registration?.Email || "email not yet stored for this registration";
        emailAndIndexMap.set(email, index);
    });

    const emailIndexFromMap = emailAndIndexMap.get(Email);

    const emailExistsInCurrentRegistration = !!(
        emailIndexFromMap !== undefined &&
        emailIndexFromMap !== currentRegistration
    );

    return emailExistsInCurrentRegistration;
};

export const handleVerificationError = ({
    dispatchUpdateLastVerifiedEmail,
    dispatchUpdateEmailVerificationInFlight,
    dispatchUpdateEmailHasBeenVerified,
    dispatchUpdateYourFundraisingDashboard,
    Email,
    error,
    setSubmitting,
}) => {
    dispatchUpdateLastVerifiedEmail(Email);
    dispatchUpdateEmailVerificationInFlight(false);
    dispatchUpdateEmailHasBeenVerified(false);
    dispatchUpdateYourFundraisingDashboard("");

    log("error", error);
    setSubmitting(false);

    // Set validation.previousRegistrationIsFetchingValidation to false in
    // the Redux store as the data has been returned
};

export const handleVerificationSuccess = ({
    dispatchUpdateLastVerifiedEmail,
    dispatchUpdateEmailVerificationInFlight,
    dispatchUpdateEmailHasBeenVerified,
    dispatchUpdateEmailExistsInPreviousRegistration,
    dispatchUpdateYourFundraisingDashboard,
    Email,
    response,
}) => {
    const {
        data: { validation, success },
    } = response;
    const { previousRegistrationHasValidationError, yourFundraisingDashboard } =
        validation;
    if (success) {
        dispatchUpdateLastVerifiedEmail(Email);
        dispatchUpdateEmailVerificationInFlight(false);
        dispatchUpdateEmailHasBeenVerified(
            !previousRegistrationHasValidationError,
        );
        dispatchUpdateEmailExistsInPreviousRegistration(
            previousRegistrationHasValidationError,
        );
        dispatchUpdateYourFundraisingDashboard(yourFundraisingDashboard);

        return;
    }
    // there was some kind of BE error but we used status 200 anyway
    handleVerificationError({
        dispatchUpdateLastVerifiedEmail,
        dispatchUpdateEmailVerificationInFlight,
        dispatchUpdateEmailHasBeenVerified,
        dispatchUpdateYourFundraisingDashboard,
        Email,
        // figure out what to do with these
        error: "",
        setSubmitting: () => {},
    });
};
